/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Priceunavailable1Inputs */

const en_priceunavailable1 = /** @type {(inputs: Priceunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price unavailable`)
};

const de_priceunavailable1 = /** @type {(inputs: Priceunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis nicht verfügbar`)
};

/**
* | output |
* | --- |
* | "Price unavailable" |
*
* @param {Priceunavailable1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const priceunavailable1 = /** @type {((inputs?: Priceunavailable1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Priceunavailable1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_priceunavailable1(inputs)
	return de_priceunavailable1(inputs)
});
export { priceunavailable1 as "priceUnavailable" }